/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { Card, Form, FormControl, InputGroup } from 'react-bootstrap';
import SDUserSelect from '../SDUserSelect';
import SDCategorySelect from '../SDCategorySelect';
import { sdUpdateIssue } from 'services/service-desk/sdService';
import SDPrioritySelect from '../SDPrioritySelect';
import { sdFilterUsersByProjectAndAgents, sdShowToast } from 'helpers/sdHelper';

import SDStatusSelect from '../SDStatusSelect';
import SDCreatableUserSelect from '../SDCreateableUserSelect';

const SDIssueControls = ({ issue, users, me, onChange }) => {
  const [isUpdatingIssue, setIsUpdatingIssue] = useState(false);

  const updateIssue = (body) => {
    setIsUpdatingIssue(true);
    sdUpdateIssue(issue.id, body).then(res => {
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      sdShowToast("Failed to update issue", true);
    }).finally(() => {
      setIsUpdatingIssue(false);
    })
  }

  const updateStatus = (val) => {
    updateIssue({ statusId: val });
  }

  const updateReportedBy = (val) => {
    sdUpdateIssue(issue.id, {
      reportedById: val
    }).then(res => {
      console.log("Updated reported by success");
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      console.log("Updated reported by failed");
      sdShowToast("Failed to update issue", true);
    });
  }

  const updateAssignedTo = (val) => {
    sdUpdateIssue(issue.id, {
      assignedToId: val
    }).then(res => {
      console.log("Updated assigned to success");
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      console.log("Updated assigned to  failed");
      sdShowToast("Failed to update issue", true);
    });
  }

  const updatePriority = (val) => {
    sdUpdateIssue(issue.id, {
      priorityId: val
    }).then(res => {
      console.log("Updated priority to success");
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      console.log("Updated priority to  failed");
      sdShowToast("Failed to update issue", true);
    });
  }

  const updateCategory = (val) => {
    sdUpdateIssue(issue.id, {
      categoryId: val
    }).then(res => {
      console.log("Updated category to success");
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      console.log("Updated category to  failed");
      sdShowToast("Failed to update issue", true);
    });
  }

  const updateCustomField = (key, value) => {
    let body = {}
    body["customFields"] = {}
    body["customFields"][key] = value;
    console.log(body);

    sdUpdateIssue(issue.id, body
    ).then(res => {
      console.log("Updated custom field");
      sdShowToast("Issue Updated", false);
      onChange();
    }).catch(err => {
      console.log("Updated custom field failed");
      sdShowToast("Failed to update issue", true);
    });
  }

  return (

    <Card>
      {/* <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
        <h5 className="mb-0">Issue Controls</h5>
        <Link
          to="/e-commerce/shopping-cart"
          className="btn btn-link btn-sm btn-reveal text-600"
        >
          <FontAwesomeIcon icon="pencil-alt" />
        </Link>
      </Card.Header> */}

      <Card.Body>

        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Status</Form.Label>
          <SDStatusSelect initialValue={issue.status.id} onUpdate={updateStatus} statuses={issue.statuses}></SDStatusSelect>
        </Form.Group>

        {/* Issue Priority (Not editable) */}
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Priority</Form.Label>
          <SDPrioritySelect initialValue={issue.priority.id} onUpdate={updatePriority} priorities={issue.priorities}></SDPrioritySelect>
        </Form.Group>

        {/* Issue Category */}
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Category</Form.Label>
          <SDCategorySelect initialValue={issue.category ? issue.category.id : 0} onUpdate={updateCategory} categories={issue.categories}></SDCategorySelect>
        </Form.Group>

        {/* Issue Reporter */}
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Reported By</Form.Label>
          <SDCreatableUserSelect initialValue={issue.reportedBy.id} onUpdate={updateReportedBy} users={users} projectId={issue.project.id}></SDCreatableUserSelect>
        </Form.Group>

        {/* Issue Assignee */}
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Assigned To</Form.Label>
          <SDUserSelect initialValue={issue.assignedTo ? issue.assignedTo.id : 0} onUpdate={updateAssignedTo} users={sdFilterUsersByProjectAndAgents(users, issue.project.id)} hasInitialOption={true}
            quickLinkShow={true} quickLinkText="Assign To Me" quickLinkId={me.id}></SDUserSelect>
        </Form.Group>

        {/* Issue custom fields */}
        {issue.customFields && Object.keys(issue.customFields).length > 0 ? <>
        <hr></hr>
        <h6>Custom Fields</h6>
        {Object.keys(issue.customFields).map((key) => (
          <div key={key}>
            <CustomFieldTextEdit fieldKey={key} fieldValue={issue.customFields[key]} onChangeHandler={updateCustomField}></CustomFieldTextEdit>
          </div>

        ))}
        </>
        : <></>}

        
      </Card.Body>
    </Card>);
}

const CustomFieldTextEdit = ({ fieldKey, fieldValue, onChangeHandler }) => {
  const [value, setValue] = useState(fieldValue);
  const [changed, setChanged] = useState(false);
  return (

    <InputGroup className="mb-3">
      <InputGroup.Text id="basic-addon1">{fieldKey}</InputGroup.Text>
      <FormControl
        placeholder={fieldKey}
        aria-label={fieldKey}
        aria-describedby="basic-addon1"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          if (!changed) {
            setChanged(true);
          }
        }}
        onBlur={(e) => {

          if (!e.currentTarget.contains(document.activeElement)) {
            if (changed) {
              onChangeHandler(fieldKey, e.target.value);
              setChanged(false);
            }

          }
        }}
      />
    </InputGroup>


  )
}
export default SDIssueControls;